import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../common/Header";
import Footer from "../common/Footer";
import "../styles/Home.css";
import { getVisitIds } from "../services/service.js";
import Loader from "../common/Loader";

function Home() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  const fetchData = async () => {
    try {
      let response = await getVisitIds(id);
      response = {
        ...response,
        doctors_advice: response.doctors_advice
          ? response.doctors_advice.split("\r\n")
          : [],
        diagnosis: response.diagnosis ? response.diagnosis.split("\r\n") : [],
        present_complaints: response.present_complaints
          ? response.present_complaints.split("\r\n")
          : [],
        systematic_disease_history: response.systematic_disease_history
          ? response.systematic_disease_history.split("\r\n")
          : [],
        patient_address: response.patient_address
          ? response.patient_address.split("\r\n")
          : [],
        footer: response.footer ? response.footer.split("\r\n") : [],
        patient_name: response.patient_name
          ? response.patient_name.split("\r\n")
          : [],
        advised_inves: response.advised_inves
          ? response.advised_inves.split("\r\n")
          : [],
      };
      if (response) setData(response);
      else setData(null);
    } catch (error) {
      console.log("error", error);
      setData(null);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {!loading ? (
        data ? (
          data?.method &&
          data?.vision &&
          data?.adv_glasses &&
          Array.isArray(data?.method) &&
          Array.isArray(data?.vision) &&
          Array.isArray(data?.adv_glasses) &&
          (data?.vision.length ||
            data?.adv_glasses.length ||
            data?.method.length) ? (
            <div className="main-home-page">
              <div className="main-wrapper">
                <Header heading={data?.header}></Header>
                <div className="home-content">
                  {data?.mr_no ? (
                    <div className="title">
                      <span className="heading">MR No. :</span>
                      <span className="value">{data?.mr_no}</span>
                    </div>
                  ) : (
                    ``
                  )}
                  {data?.visit_date ? (
                    <div className="title">
                      <span className="heading">Visit Date/Time :</span>
                      <span className="value">{data?.visit_date}</span>
                    </div>
                  ) : (
                    ``
                  )}
                  {data?.patient_name &&
                  Array.isArray(data?.patient_name) &&
                  data?.patient_name.length ? (
                    <div className="title">
                      <span className="heading">Patient Name :</span>
                      <span className="value">
                        {data?.patient_name.map((patientName, index) => {
                          return <span key={index}>{patientName}</span>;
                        })}
                      </span>
                    </div>
                  ) : (
                    ``
                  )}
                  {data?.age ? (
                    <div className="title">
                      <span className="heading">Age/Sex :</span>
                      <span className="value">
                        {data?.age} / {data?.gender}
                      </span>
                    </div>
                  ) : (
                    ``
                  )}
                  {data?.patient_address &&
                  Array.isArray(data?.patient_address) &&
                  data?.patient_address.length ? (
                    <div className="title">
                      <span className="heading">Patient Address :</span>
                      <span className="value">
                        {data?.patient_address.map((patientAddress, index) => {
                          return <p key={index}>{patientAddress}</p>;
                        })}
                      </span>
                    </div>
                  ) : (
                    ``
                  )}
                </div>
                <div className="prescription">
                  {data?.present_complaints &&
                  Array.isArray(data?.present_complaints) &&
                  data?.present_complaints.length ? (
                    <div className="title">
                      <div className="heading">Present Complaints :</div>
                      <div className="value">
                        {data?.present_complaints.map(
                          (presentComplaints, index) => {
                            return <p key={index}>{presentComplaints}</p>;
                          }
                        )}
                      </div>
                    </div>
                  ) : (
                    ``
                  )}
                  {data?.systematic_disease_history &&
                  Array.isArray(data?.systematic_disease_history) &&
                  data?.systematic_disease_history.length ? (
                    <div className="title">
                      <div className="heading">Systemic Disease History :</div>
                      <div className="value">
                        {data?.systematic_disease_history.map(
                          (diseaseHistory, index) => {
                            return <p key={index}>{diseaseHistory}</p>;
                          }
                        )}
                      </div>
                    </div>
                  ) : (
                    ``
                  )}
                </div>
                <div className="inspection-details">
                  <table>
                    <thead>
                      <tr>
                        <th>Vision</th>
                        <th colSpan={2}>Distance Vision</th>
                        <th colSpan={2}>Near Vision</th>
                      </tr>
                      <tr className="child-head">
                        <th></th>
                        <th>Right Eye</th>
                        <th>Left Eye</th>
                        <th>Right Eye</th>
                        <th>Left Eye</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.vision && data?.vision.length ? (
                        data?.vision.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{item.vision}</td>
                              <td>{item.distance_vision_right}</td>
                              <td>{item.distance_vision_left}</td>
                              <td>{item.near_vision_right}</td>
                              <td>{item.near_vision_left}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr className="empty-row"></tr>
                      )}
                    </tbody>
                  </table>

                  <table className="method">
                    <thead>
                      <tr>
                        <th>Method Name</th>
                        <th>IOP Time</th>
                        <th>Right Eye</th>
                        <th>Left Eye</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.method &&
                      Array.isArray(data?.method) &&
                      data?.method.length ? (
                        data?.method.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{item.name}</td>
                              <td>{item.iop}</td>
                              <td>{item.right}</td>
                              <td>{item.left}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr className="empty-row"></tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="glasses-table">
                  <table className="method">
                    <thead>
                      <tr>
                        <th>Adv. Glasses</th>
                        <th colSpan={6}>Right Eye</th>
                        <th colSpan={6}>Left Eye</th>
                      </tr>
                      <tr className="child-head">
                        <th></th>
                        <th>Sph</th>
                        <th>Cyl</th>
                        <th>Axis</th>
                        <th>Prism</th>
                        <th>V/A</th>
                        <th>N/V</th>
                        <th>Sph</th>
                        <th>Cyl</th>
                        <th>Axis</th>
                        <th>Prism</th>
                        <th>V/A</th>
                        <th>N/V</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.adv_glasses && data?.adv_glasses.length ? (
                        data?.adv_glasses.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{item.glasses}</td>
                              <td>{item.right_sph}</td>
                              <td>{item.right_cyl}</td>
                              <td>{item.right_axis}</td>
                              <td>{item.right_prism}</td>
                              <td>{item.right_va}</td>
                              <td>{item.right_nv}</td>
                              <td>{item.left_sph}</td>
                              <td>{item.left_cyl}</td>
                              <td>{item.left_axis}</td>
                              <td>{item.left_prism}</td>
                              <td>{item.left_va}</td>
                              <td>{item.left_nv}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr className="empty-row"></tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="diagnosis-comment">
                  {data?.diagnosis &&
                  Array.isArray(data?.diagnosis) &&
                  data?.diagnosis.length ? (
                    <div className="title">
                      <div className="heading">
                        Diagnosis Comments/Clinical Impression :
                      </div>
                      <div className="value">
                        {data?.diagnosis.map((diagNosis, index) => {
                          return <p key={index}>{diagNosis}</p>;
                        })}
                      </div>
                    </div>
                  ) : (
                    ``
                  )}
                  {data?.advised_inves &&
                  Array.isArray(data?.advised_inves) &&
                  data?.advised_inves.length ? (
                    <div className="title">
                      <div className="heading">Advised Investigations :</div>
                      <div className="value">
                        {data?.advised_inves.map((advisedInves, index) => {
                          return <p key={index}>{advisedInves}</p>;
                        })}
                      </div>
                    </div>
                  ) : (
                    ``
                  )}
                  {data?.doctors_advice &&
                  Array.isArray(data?.doctors_advice) &&
                  data?.doctors_advice.length ? (
                    <div className="title">
                      <div className="heading">Doctor’s Advice :</div>
                      <div className="value">
                        {data?.doctors_advice.map((doctorsAdvice, index) => {
                          return <p key={index}>{doctorsAdvice}</p>;
                        })}
                      </div>
                    </div>
                  ) : (
                    ``
                  )}
                  {data?.next_review_heading ? (
                    <div className="next-review">
                      Next Review : {data?.next_review_heading}
                    </div>
                  ) : (
                    ``
                  )}
                </div>
              </div>
              {data?.footer &&
              Array.isArray(data?.footer) &&
              data?.footer.length ? (
                <Footer heading={data?.footer}></Footer>
              ) : (
                ``
              )}
            </div>
          ) : (
            <div className="prescription-not-generated">
              Prescription not generated.
            </div>
          )
        ) : (
          <div className="no-data">
            <h3>No data Found</h3>
          </div>
        )
      ) : (
        <Loader show={loading} />
      )}
    </>
  );
}
export default Home;
